import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, ActivityIndicator } from "react-native";
import ENV from "app/utils/ENV";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import chapterActions from "app/utils/chapterActions";
import alertActions from "app/utils/alertActions";
import timeHelpers from "app/utils/timeHelpers";
// import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import DatePicker from "app/components/DatePicker";

import { StyleContext } from "app/contexts/Style";

export default class ChapterFrom extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    chapter: PropTypes.object,
  };

  constructor(props) {
    super(props);
    let title = props.chapter?.title || "";
    let startAt = props.chapter?.start_at || null;
    let endAt = props.chapter?.end_at || null;
    this.state = {
      title,
      startAt,
      endAt,
      isDirty: false,
      loading: false,
    };
  }

  render() {
    let { chapter } = this.props;
    let { title, startAt, endAt } = this.state;

    let existingChapter = !!chapter?.id && typeof chapter.id !== "string";
    return (
      <View style={this.styles().wrappper}>
        <View style={[this.styles().row, { zIndex: 1 }]}>
          <DatePicker
            dateOnly
            // selected={new Date(startAt)}
            selected={timeHelpers.dateToDateTime(startAt)}
            value={timeHelpers.dateToDateTime(startAt)}
            onChange={(timestamp) => {
              let startAt = timeHelpers.dateTimeToDate(timestamp);
              let endAt = this.state.endAt;
              let title = this.state.title;
              let range = this.props.range || 1;
              if (!endAt || endAt < startAt) {
                endAt = timeHelpers.tomorrow(timestamp, range - 1);
                endAt = timeHelpers.dateTimeToDate(endAt);
              }
              if (
                title == timeHelpers.getDayOfWeek(this.state.startAt) ||
                !title?.length
              ) {
                if (startAt == endAt) {
                  title = timeHelpers.getDayOfWeek(startAt);
                } else {
                  title = "";
                }
                this.props.onUpdateTitle && this.props.onUpdateTitle(title);
              }
              this.setState({
                startAt,
                endAt,
                title,
                isDirty: true,
              });
            }}
            inputStyle={{
              flex: 1,
              width: 100,
              backgroundColor: this.context.colors.fill,
              paddingHorizontal: this.context.sizes.small,
            }}
            style={{
              flex: 1,
            }}
            placeholderText={"Start date"}
          />
          <Text> – </Text>
          <DatePicker
            dateOnly
            // selected={new Date(endAt)}
            selected={timeHelpers.dateToDateTime(endAt)}
            value={timeHelpers.dateToDateTime(endAt)}
            onChange={(timestamp) => {
              let startAt = this.state.startAt;
              let endAt = timeHelpers.dateTimeToDate(timestamp);
              if (endAt < startAt) {
                endAt = startAt;
              }
              let title = this.state.title;
              if (
                title == timeHelpers.getDayOfWeek(startAt) ||
                !title?.length
              ) {
                if (startAt == endAt) {
                  title = timeHelpers.getDayOfWeek(startAt);
                } else {
                  title = "";
                }
                this.props.onUpdateTitle && this.props.onUpdateTitle(title);
              }
              this.setState({
                title,
                endAt,
                isDirty: true,
              });
            }}
            inputStyle={{
              flex: 1,
              width: 100,
              backgroundColor: this.context.colors.fill,
              paddingHorizontal: this.context.sizes.small,
            }}
            style={{
              flex: 1,
            }}
            placeholderText={"End date"}
          />
        </View>
        <View style={[this.styles().row]}>
          <TouchableOpacity onPress={this.props.onCancel}>
            <Text button>Cancel</Text>
          </TouchableOpacity>
          {!!this.props.allowDelete && (
            <TouchableOpacity onPress={this.handleDelete}>
              <Text button>Delete</Text>
            </TouchableOpacity>
          )}
          {!existingChapter && (
            <TouchableOpacity onPress={this.handleClear}>
              <Text button>Clear</Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity onPress={this.handleSubmit}>
            <Text button selectedButton>
              Save
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  handleClear = () => {
    this.setState({
      startAt: null,
      endAt: null,
    });
    this.props.onUpdateTitle && this.props.onUpdateTitle("");
  };

  handleSubmit = async () => {
    let { chapter, parentChapter } = this.props;
    let { startAt, endAt } = this.state;
    let { title } = this.props;
    this.setState({ loading: true });
    let data = {
      title,
      start_at: startAt,
      end_at: endAt,
    };
    let res;
    if (!!chapter?.id && typeof chapter.id !== "string") {
      res = await chapterActions.update(chapter.id, data);
    } else {
      res = await chapterActions.create(data, parentChapter);
    }
    console.log(res);
    if (res?.success) {
      this.props.onUpdateChapter(res.chapter);
    }
  };

  handleDelete = async () => {
    let confirm = await alertActions.confirm({
      title: "Delete chapter?",
      subtitle: "This cannot be undone.",
      text: "Delete",
    });
    if (!confirm) return;

    let { chapter } = this.props;
    this.setState({ loading: true });
    let res = await chapterActions.delete(chapter.id);
    if (res?.success) {
      this.props.onDelete();
      this.props.onCancel();
    }
  };

  styles = () => ({
    wrappper: {
      alignItems: "flex-start",
      // alignItems: "center",
      // alignItems: "stretch",
      padding: this.context.sizes.large,
      paddingTop: 0,
    },
    row: {
      width: "100%",
      flexDirection: "row",
      marginTop: this.context.sizes.large,
    },
  });
}
